'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BrowserView;

var _preact = require('preact');

var _newFolder = require('../../containers/newFolder.js');

var _newFolder2 = _interopRequireDefault(_newFolder);

var _folderList = require('../../containers/folderList.js');

var _folderList2 = _interopRequireDefault(_folderList);

var _fileList = require('../../containers/fileList.js');

var _fileList2 = _interopRequireDefault(_fileList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BrowserView(props) {
  var openFolders = (props.openFolders || []).map(function (folder_id) {
    var folder_list = props.folders.filter(function (folder) {
      return folder.id === folder_id;
    });
    if (!folder_list.length) return;
    var folder = folder_list[0];
    return (0, _preact.h)(_fileList2.default, { folder: folder });
  });

  return (0, _preact.h)(
    'div',
    { 'class': 'column' },
    (0, _preact.h)(_newFolder2.default, null),
    (0, _preact.h)(_folderList2.default, null),
    openFolders
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Browser/BrowserView.jsx
// module id = 73
// module chunks = 0